import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api_urls } from "../../utilities";
import { getAgentService, getService, postAgentService, postService } from "../services";

function normalizeInvoiceList(inner) {
  if (inner == null) return [];
  if (Array.isArray(inner)) return inner;
  return inner.data ?? inner.invoices ?? inner.records ?? inner.list ?? [];
}

function isAgentPortal(getState) {
  return getState().auth?.portal === "agent";
}

export const fetchInvoices = createAsyncThunk(
  "invoice/fetchInvoices",
  async (_, { getState, rejectWithValue }) => {
    try {
      const response = isAgentPortal(getState)
        ? await getAgentService(api_urls.invoices, {})
        : await getService(api_urls.invoices, {});
      const envelope = response.data ?? {};
      const code = envelope.code ?? envelope.status;
      if (typeof code === "number" && code !== 200) {
        return rejectWithValue({
          httpStatus: response.status,
          body: envelope,
        });
      }
      const inner = envelope.data ?? envelope;
      return normalizeInvoiceList(inner);
    } catch (error) {
      return rejectWithValue({
        httpStatus: error?.status,
        body: error?.data ?? { message: error?.message },
      });
    }
  }
);

export const createInvoice = createAsyncThunk(
  "invoice/create",
  async (payload, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = isAgentPortal(getState)
        ? await postAgentService(api_urls.invoices, payload)
        : await postService(api_urls.invoices, payload);
      const envelope = response.data ?? {};
      const code = envelope.code ?? envelope.status;
      if (typeof code === "number" && code !== 200) {
        return rejectWithValue({
          httpStatus: response.status,
          body: envelope,
        });
      }
      dispatch(fetchInvoices());
      return envelope.data ?? envelope;
    } catch (error) {
      return rejectWithValue({
        httpStatus: error?.status,
        body: error?.data ?? { message: error?.message },
      });
    }
  }
);

const initialState = {
  list: [],
  loading: false,
  creating: false,
};

export const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvoices.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInvoices.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.list = Array.isArray(payload) ? payload : [];
      })
      .addCase(fetchInvoices.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createInvoice.pending, (state) => {
        state.creating = true;
      })
      .addCase(createInvoice.fulfilled, (state) => {
        state.creating = false;
      })
      .addCase(createInvoice.rejected, (state) => {
        state.creating = false;
      });
  },
});

export default invoiceSlice.reducer;
